// Shared persistence for the Instruction Assistant's revised section preferences.
// Every host surface (both visit views + Note Settings) saves the same way — one
// editConfigBulk call — so this isn't rewritten per host. It only persists; each
// host updates its own local instruction/example state
// afterward (the shapes of that state differ between surfaces).
//
// `newInstructions` is the `{ [section]: "full new instruction" }` map returned
// by generateInstructionRevisions; `newExamples` is the corresponding
// `{ [section]: ["full replacement example", ...] }` map (changed sections only).
export async function persistInstructionUpdates(
  apiClient,
  configId,
  newInstructions = {},
  newExamples = {},
) {
  const bulkEdits = [
    ...Object.entries(newInstructions).map(([key, value]) => ({
      fieldName: 'update_question_value',
      key,
      value,
    })),
    ...Object.entries(newExamples).map(([key, value]) => ({
      fieldName: 'samples',
      key,
      value,
    })),
  ];
  if (bulkEdits.length === 0) {
    return {};
  }
  const data = await apiClient.editConfigBulk(configId, bulkEdits);
  if (data && data.error) {
    throw new Error(
      typeof data.error === 'string'
        ? data.error
        : 'Failed to save preferences.',
    );
  }
  if (Object.keys(newExamples).length === 0) {
    return {};
  }
  const details = await apiClient.getConfigDetails(configId);
  if (
    !details ||
    details.error ||
    !details.samples ||
    Array.isArray(details.samples)
  ) {
    throw new Error('Saved preferences, but could not reload the examples.');
  }
  const savedExamples = details.samples;
  return Object.fromEntries(
    Object.keys(newExamples).map((key) => [key, savedExamples[key] || []]),
  );
}
